/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { auditLogRefreshKeys } from "./sharedRefreshKeys";

const baseMealPeriodKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.meal_periods)
);

const mealPeriodImportKeys = mergeQueryKeys(
  baseMealPeriodKeys,
  getBaseQueryKey(Query_Keys.daily_logbook_detail),
  auditLogRefreshKeys
);

export const mealPeriodMutationKeyGroups = {
  fetch: mealPeriodImportKeys,
};
